<!-- crud asignar url de la api URL="url de la api" titulo="un titulo para la pestaña de la pagina" [dato]="variable que contiene el formulario]-->
<app-formulario #ctrl URL="sisGrupo" titulo="Grupo / Sistema" [dato]="dato" ></app-formulario>

<!-- Menu principal "-->
<app-sistema-menu></app-sistema-menu>

<div class="contenedor columns " style="height:100%; ">
    <div class="column is-2 is-hidden-mobile menu-izquierda">

        <!-- Menu izquierda del modulo enviroment" -->
        <app-sistema-menu-aside ></app-sistema-menu-aside>
    </div>
    <div class="column" style="padding:0px;">
        <div style="background: #FFF; border-radius: 1em; ">

            <!-- formulario -->
            <form name="form" novalidate [formGroup]="dato" (ngSubmit)="ctrl.enviar()" >
                <section class="hero is-primary">
                    <div class="hero-body">

                        <!-- Opciones  -->
                        <app-formulario-opciones [ctrl]="ctrl" [id]="ctrl.dato.id"></app-formulario-opciones>
                    </div>
                </section>

                <section class="section" style="overflow:auto; height: 85.8vh; width: 83vw; padding: 1rem !important;" >

                    <div class="field">
                        <label class="label">Nombre:</label>
                        <p class="control has-icons-left has-icons-right">
                            <input class="input" autofocus type="text" [ngClass]="{'is-danger': ctrl.dato.get('nombre').hasError('required') }"
                                placeholder="Nombre" formControlName="nombre">
                            <span class="icon is-small is-right" *ngIf="ctrl.dato.get('nombre').hasError('required') ">
                                <i class="fa fa-warning"></i>
                            </span>
                            <span class="help is-danger" *ngIf="ctrl.dato.get('nombre').hasError('required') ">Este campo es requerido.</span>
                        </p>
                    </div>
                    <br>
                    <section class="hero is-light">
                        <div class="hero-body">
                            <div class="container" style="margin: -18px 18px;">
                                <h1 class="title">
                                    <span class="icon is-medium"><i class="icon-padlock"></i></span> Permisos <a class="button  is-info" id="catalogos" (click)="ctrl.cargarCatalogo('catalogo', 'permiso');"><span class="icon "><i class="icon-worldwide"></i></span></a>
                                </h1>
                                <h2 class="subtitle">
                                    Selecciona el o los permisos que estaran disponibles para el grupo
                                </h2>
                            </div>
                        </div>
                    </section>
                    <br>
                    <div class="tabs is-boxed">
                        <ul>
                            <li [ngClass]="{ 'is-active' : tab == i}" *ngFor="let padre of ctrl.catalogo; let i = index;">
                                <a (click)="tab=i">
                                    <span>{{padre.nombre}}</span>
                                </a>
                            </li>
                        </ul>
                    </div>

                    <div class="columns" >
                        <div [ngClass]="{ 'is-hidden': tab != i2}" *ngFor="let padre of ctrl.catalogo; let i2 = index;" >
                            <span *ngIf="padre.es_super ? activar_super ? true : false : true">
                                <div class="column is-3" *ngFor="let hijos of padre.hijos" style="float:left; min-width:300px">
                                    <nav class="panel">
                                        <div class="panel-heading">
                                            <div class="field">
                                                <div class="b-checkbox is-info">
                                                    <input id="{{hijos.controlador}}" class="styled" type="checkbox"
                                                    (click)="todosAccion(hijos.controlador, hijos.accion, ctrl.dato.controls.permisos)">
                                                    <label for="{{hijos.controlador}}">
                                                        {{hijos.nombre}}
                                                    </label>
                                                </div>
                                            </div>

                                        </div>
                                        <label class="panel-block" *ngFor="let accion of hijos.accion">
                                            <div class="field" *ngIf="accion.es_super ? activar_super ? true : false : true">
                                                <div class="b-checkbox is-info">
                                                    <input id="{{accion.id}}" class="styled"
                                                        [checked]="ctrl.dato.controls.permisos?.value[hijos?.controlador+'.'+accion?.recurso] ? true : false"
                                                        (click)="agregar_accion(hijos.controlador+'.'+accion.recurso)" type="checkbox">
                                                    <label for="{{accion.id}}">
                                                        {{accion.nombre}}
                                                    </label>
                                                </div>
                                            </div>

                                        </label>
                                    </nav>
                                </div>
                            </span>
                        </div>
                    </div>
                </section>
            </form>
        </div>
    </div>
</div>
